export const LINDENBERG_THEME =
  {
    name: 'LINDENBERG',
    light: {
      primary: '#E67F3E',
      accent: '#ffffff',
      secondary: '#7C765D',
      success: '#30B200',
      info: '#ff53d0',
      warning: '#856404',
      error: '#C71023'
    },
    dark: {
      primary: '#E67F3E',
      accent: '#ffffff',
      secondary: '#7C765D',
      success: '#30B200',
      info: '#ff53d0',
      warning: '#856404',
      error: '#C71023'
    }
  }
